export default {
    top_menu: [
        {name:'Галоўнае',    id:0},
        {name:'Шоў-бізнэс', id:1},
        {name:'Кулінарыя',  id:2},
        {name:'Палітыка',   id:3},
        {name:'+18',  id:4},
        {name:'Грамадства',   id:5},
        {name:'Здароўе',   id:6},
    ],
    read_other: 'Чытаць далей',
    read_more:  'Больш падрабязна',
    not_found:  'Нічога не знойдзена',
    read_also:  'Чытайце таксама',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Ўсе правы абаронены.',
    subscribe: 'Падпісацца',

    thank_order: 'ДЗЯКУЙ ЗА ЗАКАЗ',
    specialist_contact: 'Наш спецыяліст хутка звяжацца з вамі, чакайце нашага званка.',
    attention: 'Скідкі ад партнёраў:',
    hurry: 'Спяшайцеся, час актывацыі зніжкі абмежавана! У вас ёсць ўсяго <span id="time" class="time">30:00</span> хвілін, каб выбраць адзін з гэтых унікальных тавараў:',

    hour_ago1: "гадзіну таму",
    hour_ago2: "гадзіны назад",
    hour_ago3: "гадзін таму",
    new_publications: "новыя публікацыі",
    read: "чытаць",
    today_at: "Сёння ў",
    author_names: ['Дмитрий Колдун','Олег Савченко','Ядвига Поплавская'],
    main_news: "Галоўныя навіны",
    leave_already: "Ужо сыходзіце? Пачакайце, мы абнавілі для Вас навіны",
    already_shared: "ўжо падзяліліся"

}